import Component from '@glimmer/component'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { eq } from 'ember-truth-helpers'
import { FooterReading } from 'teacher-ui-client/components/footer-main/reading'
import { FooterWriting } from 'teacher-ui-client/components/footer-main/writing'
import { FooterMaths } from 'teacher-ui-client/components/footer-main/maths'
import HomeschoolFooter from './footer-main/homeschool'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { service } from '@ember/service'

interface Signature {
  Element: HTMLElement
}

export class FooterMain extends Component<Signature> {
  @service sideNav!: SideNavService

  <template>
    {{#if this.sideNav.isHomeschool}}
      <HomeschoolFooter ...attributes @countryCode={{this.sideNav.countryCode}} />
    {{else if (eq this.sideNav.currentSubscriptionType SubscriptionType.Reading)}}
      <FooterReading ...attributes @countryCode={{this.sideNav.countryCode}} />
    {{else if (eq this.sideNav.currentSubscriptionType SubscriptionType.Maths)}}
      <FooterMaths ...attributes @countryCode={{this.sideNav.countryCode}} />
    {{else if (eq this.sideNav.currentSubscriptionType SubscriptionType.Writing)}}
      <FooterWriting ...attributes @countryCode={{this.sideNav.countryCode}} />
    {{/if}}
  </template>
}

export default FooterMain
